const PRODUCT_CARD_ICON = "PRODUCT_CARD";
const PDP_MAIN = "PDP_MAIN";
const PRODUCT_CATEGORY_ICON = "PRODUCT_CATEGORY_ICON";
const PRODUCT_POST_ICON = "PRODUCT_POST_ICON";
const PRODUCT_HOT_ALBUM = "PRODUCT_HOT_ALBUM";
const PRODUCT_HOT_ALBUM_BG = "PRODUCT_HOT_ALBUM_BG";
const HOME_MAIN_BANNER = "HOME_MAIN_BANNER";
const HOME_AD_SLOT = "HOME_AD_SLOT";
const PDP_BANNER = "PDP_BANNER";
const RTG_BANNER = "RTG_BANNER";
const USER_AVATAR = "USER_AVATAR";
const MESSAGE_ICON = "MESSAGE_ICON";
const VIDEO_CARD_ICON = "VIDEO_CARD_ICON";
const VIDEO_COVER = "VIDEO_COVER";
const EVENT_ICON = "EVENT_ICON";
const EVENT_BG = "EVENT_BG";
const EVENT_CARD = "EVENT_CARD";
const RTG_BG = "RTG_BG";
const RTG_LOGO = "RTG_LOGO";
const RECIPE_ICON = "RECIPE_ICON";
const RECIPE_PDP = "RECIPE_PDP";
const ORDER_POST = "ORDER_POST";
const SHARE_POPUP_ICON = "SHARE_POPUP_ICON";
const RTG_CUISINE_ICON = "RTG_CUISINE_ICON";
const RTG_COCHE_MASK_ARROW = "RTG_COCHE_MASK_ARROW";
const RTG_CART_ICON = "RTG_CART_ICON";
const ImageStandards = {
  [PRODUCT_CARD_ICON]: {
    renderWidth: 170,
    renderHeight: 170
  },
  [PDP_MAIN]: {
    renderWidth: 375,
    renderHeight: 375
  },
  [PRODUCT_CATEGORY_ICON]: {
    renderWidth: 56,
    renderHeight: 56
  },
  [PRODUCT_POST_ICON]: {
    renderWidth: 136,
    renderHeight: 136
  },
  [PRODUCT_HOT_ALBUM]: {
    renderWidth: 136,
    renderHeight: 136
  },
  [PRODUCT_HOT_ALBUM_BG]: {
    renderWidth: 375,
    renderHeight: 200
  },
  [HOME_MAIN_BANNER]: {
    renderWidth: 313,
    renderHeight: 213
  },
  [HOME_AD_SLOT]: {
    renderWidth: 375,
    renderHeight: 68
  },
  [PDP_BANNER]: {
    renderWidth: 375,
    renderHeight: 68
  },
  [RTG_BANNER]: {
    renderWidth: 330,
    renderHeight: 134
  },
  [USER_AVATAR]: {
    renderWidth: 72,
    renderHeight: 72
  },
  [MESSAGE_ICON]: {
    renderWidth: 76,
    renderHeight: 76
  },
  [VIDEO_CARD_ICON]: {
    renderWidth: 375,
    renderHeight: 500,
    devicePixelRatio: 2
  },
  [VIDEO_COVER]: {
    renderWidth: 375,
    renderHeight: 500,
    devicePixelRatio: 2
  },
  [EVENT_ICON]: {
    renderWidth: 200,
    renderHeight: 200
  },
  [EVENT_BG]: {
    renderWidth: 375,
    renderHeight: 230
  },
  [EVENT_CARD]: {
    renderWidth: 375,
    renderHeight: 140
  },
  [RTG_BG]: {
    renderWidth: 375,
    renderHeight: 154
  },
  [RTG_LOGO]: {
    renderWidth: 48,
    renderHeight: 48
  },
  [RECIPE_ICON]: {
    renderWidth: 80,
    renderHeight: 80
  },
  [RECIPE_PDP]: {
    renderWidth: 375,
    renderHeight: 375
  },
  [ORDER_POST]: {
    renderWidth: 108,
    renderHeight: 108
  },
  [SHARE_POPUP_ICON]: {
    renderWidth: 64,
    renderHeight: 64
  },
  [RTG_CUISINE_ICON]: {
    renderWidth: 50,
    renderHeight: 50
  },
  [RTG_COCHE_MASK_ARROW]: {
    renderWidth: 50,
    renderHeight: 50
  },
  [RTG_CART_ICON]: {
    renderWidth: 80,
    renderHeight: 80
  }
};
export {
  EVENT_BG,
  EVENT_CARD,
  EVENT_ICON,
  HOME_AD_SLOT,
  HOME_MAIN_BANNER,
  ImageStandards,
  MESSAGE_ICON,
  ORDER_POST,
  PDP_BANNER,
  PDP_MAIN,
  PRODUCT_CARD_ICON,
  PRODUCT_CATEGORY_ICON,
  PRODUCT_HOT_ALBUM,
  PRODUCT_HOT_ALBUM_BG,
  PRODUCT_POST_ICON,
  RECIPE_ICON,
  RECIPE_PDP,
  RTG_BANNER,
  RTG_BG,
  RTG_CART_ICON,
  RTG_COCHE_MASK_ARROW,
  RTG_CUISINE_ICON,
  RTG_LOGO,
  SHARE_POPUP_ICON,
  USER_AVATAR,
  VIDEO_CARD_ICON,
  VIDEO_COVER,
  ImageStandards as default
};
//# sourceMappingURL=imageStandards.js.map
